import { ca } from '@cian/analytics';

export const trackButtonClick = (offerId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click',
    label: 'ReestrInformation',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export const trackLinkClick = (offerId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Click',
    label: 'ReestrInformationLink',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};
